import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";

import {companyVehiclesService} from "../services";
import type {UpdateCompanyVehiclePayload} from "../types";

type Args = {id: number; payload: UpdateCompanyVehiclePayload};

export function useUpdateCompanyVehicle() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({id, payload}: Args) => companyVehiclesService.updateCompanyVehicle(id, payload),
    onSuccess: (_data, {id}) => {
      void queryClient.invalidateQueries({queryKey: ["company-vehicles"]});
      void queryClient.invalidateQueries({queryKey: ["company-vehicles", id]});
      void queryClient.invalidateQueries({queryKey: ["infinite-company-vehicles"]});
    },
    onError: errorHandler,
  });
}
